import C from "./constants";
import {
  getPresignedUrl, 
  postImage, 
  updateUserProfile, 
  getUserProfile,
  getUserQuestions,
  getUserAchievements
} from "~/services/profileService";
import {formatAchievementsResponse} from "./helpers";

export var save = (payload) => {
  return {type: C.SAVE_PROFILE, payload: payload};
}

export var updateErrors = (payload) => {
   return {
     type: C.UPDATE_ERRORS,
     payload: payload
   }
}

export var saving = (payload) => {
  return {type: C.UPDATE_SAVING, payload: payload};
}

export var updateEditing = (editing) => {
   return {
     type: C.UPDATE_EDITING, 
     payload: editing
   }
}

export var updateUserQuestionAnswers = (key,value) => {
  
  const payload = {question:key, answer: value};

  return {type: C.UPDATE_USER_QUESTION_ANSWERS, payload: payload};
}

export var updateProfile = (key,value) => {
  
  let payload = {};

  payload[key] = value;

  return {type: C.UPDATE_PROFILE, payload: payload};
}


export var getProfile = (userId) => (dispatch, getState) => {

  return getUserProfile(userId).then(response => {
      dispatch({
        type: C.GET_PROFILE_FULFILLED,
        payload: response
      })
  }).catch(error => {
      dispatch(updateEditing(true))
      dispatch({
        type: C.GET_PROFILE_REJECTED,
        payload: error.response.data
      })
  })
}

export var getQuestions = (userId) => {
  const payload = getUserQuestions(userId);

  return {
    type: C.GET_QUESTIONS,
    payload: payload
  }
}

export var toggleInterest = (interest) => {
  
  const payload = {interest: interest};
  
  return {type: C.TOGGLE_INTEREST, payload: payload};

}

export var uploadImage =  (userId,image)  =>  (dispatch,getState) => {

  getPresignedUrl(userId).then((response => {
    const regex   = /\/avatar\/(.)*.(?:jpeg|jpg|png)/
    const url     = response.url;
    const file    = new File([image], 'avatar');
    const prefix = 'https://snagfilms-a.akamaihd.net'

    dispatch(
      saving(true)
    )
  
    return postImage(url,file).then((response => {

      let matches   = url.match(regex);
      let avatarUrl = prefix + matches[0];
      let profile   = getState().profile.data.main;
      
      profile.avatarUrl = avatarUrl;

      dispatch(
        updateProfile('avatarUrl',avatarUrl)
      )

      dispatch(
        saveProfile(userId,profile)
      )

    }))
  }))

}

  export var saveProfile = (userId,profile) => (dispatch,getState) => {

    dispatch(
      saving(true)
    );

    return updateUserProfile(profile,userId)
    .then(response => {

      dispatch(
        saving(false)
      );

    })
    .catch(error => {

      let profileResponse = error.response.data;
      const profileError  = profileResponse.error;
      
      dispatch(
        updateErrors(profileError)
      )

      dispatch(
        saving(false)
      )
    })
  }

export const getAchievements = (userId) => {

  const payload = getUserAchievements(userId).then( (res) => formatAchievementsResponse(res.data.achievements) );
  return {type: "GET_ACHIEVEMENTS", payload: payload};

} 
